export default {
  props: {
    tagName: {
      type: String,
      default: 'div',
    },
    title: String,
  },
  computed: {
    classes() {
      return [
        'ba-modal-content',
      ];
    },
  },
};
